module.exports = __webpack_public_path__ + "static/media/download.5c5b689b.svg";